import React, { useEffect, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import Table from './Table';
import api from '~/services/api';
import { Container, TableContainer } from './styles';
import { BarLoader } from '~/components';

function FinancialApplicationList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleDelete = useCallback(async id => {
    try {
      await api.delete(`financial/${id}`);

      toast.success('Application deleted, please refresh');
    } catch (err) {
      toast.error(
        err.response &&
          err.response.data &&
          err.response.data.error &&
          typeof err.response.data.error === 'string'
          ? err.response.data.error
          : 'Error while deleting application'
      );
    }
  }, []);

  useEffect(() => {
    async function loadApplications() {
      const response = await api.get('/financial');
      setData(response.data);
      setLoading(false);
    }
    loadApplications();
  }, []);

  return (
    <Container>
      {loading ? (
        <BarLoader />
      ) : (
        <TableContainer>
          <Table data={data} handleDelete={handleDelete} />
        </TableContainer>
      )}
    </Container>
  );
}

export default FinancialApplicationList;
